import React from 'react';
import { Box, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import { getImageUrl } from '../services/api';
import Seo from '../components/Seo';

const overviewCards = [
  {
    title: 'Sales',
    image: getImageUrl('Sales.jpg', 'logos'),
  },
  {
    title: 'Lettings',
    image: getImageUrl('lettings.jpg', 'logos'),
  },
  {
    title: 'Management',
    image: getImageUrl('management.jpg', 'logos'),
  },
];

const AboutUs = () => {
  return (
    <Box sx={{ backgroundColor: '#f8fafc', minHeight: '100vh', pt: { xs: 12, md: 14 }, pb: 8 }}>
      <Seo
        title="JCP Overview"
        description="Learn more about JCP Estate Agents and our sales, lettings, and management services across Oxford and Oxfordshire."
        keywords="JCP Estate Agents, Oxford estate agents, lettings, management, sales, Oxfordshire property"
        author="JCP Estate Agents"
      />

      <Container maxWidth="xl">
        <Stack spacing={5}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ fontSize: { xs: '2.6rem', md: '4rem' }, fontWeight: 300, color: '#8b8b8b', letterSpacing: 2 }}>
              JCP OVERVIEW
            </Typography>
            <Typography sx={{ mt: 1.5, fontSize: '1rem', letterSpacing: 1.5, color: '#111827' }}>
              NEW SEARCH
            </Typography>
          </Box>

          <Grid container spacing={4} alignItems="stretch" justifyContent="center">
            <Grid item xs={12} lg={9}>
              <Grid container spacing={2.5}>
                {overviewCards.map((item) => (
                  <Grid item xs={12} sm={4} key={item.title}>
                    <Box
                      sx={{
                        position: 'relative',
                        borderRadius: 0,
                        overflow: 'hidden',
                        height: { xs: 280, md: 380, lg: 430 },
                        width: '100%',
                        '&::after': {
                          content: '""',
                          position: 'absolute',
                          inset: 0,
                          background: 'rgba(255,255,255,0.58)',
                        },
                      }}
                    >
                      <Box component="img" src={item.image} alt={item.title} sx={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
                      <Box sx={{ position: 'relative', zIndex: 1, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Typography sx={{ fontFamily: 'Playfair Display', fontSize: { xs: '1.8rem', md: '2rem' }, color: '#111827' }}>
                          {item.title}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} lg={3}>
              <Paper sx={{ p: { xs: 3, md: 4 }, height: '100%', borderRadius: 0, boxShadow: 'none', backgroundColor: 'transparent' }}>
                <Stack spacing={3} sx={{ color: '#111827', lineHeight: 2, textAlign: 'center' }}>
                  <Typography variant="body1">
                    JCP Estate and Letting Agents has become widely recognised as one of the Principal Residential Letting and Estate Agents covering property in Oxford and throughout Oxfordshire, providing sound and accurate advice underpinned by an excellent local property knowledge.
                  </Typography>
                  <Typography variant="body1">
                    With a reputation for providing clients with informed, individual advice and a proactive and innovative approach to marketing, letting and management, we have established and built a successful Independent Estate and Letting Agency firmly focused upon satisfying all the professional needs and aspirations of the more discerning vendor, purchaser, landlord or tenant throughout the county.
                  </Typography>
                  <Typography variant="body1">
                    If you are considering selling or letting your property in Oxford and would like some sound honest advice on how to achieve a premium price for your property, please do not hesitate to contact us.
                  </Typography>
                </Stack>
              </Paper>
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </Box>
  );
};

export default AboutUs;
